import commonApiService from "./commonApiService.js";
import { getTokenHeader } from "../helpers/accessTokenHelper.js";

const getCustomMenu = async () => {
    try {
        const response = await commonApiService.apiPrivate().get('/custom-menus', getTokenHeader());
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data || 'Error al obtener los datos');
    }
};

const saveOrUpdateCustomMenu = async (payload) => {
    try {
        const headers = getTokenHeader();

        if (payload.id) {
            // Actualizar
            const response = await commonApiService.apiPrivate().put(`/custom-menus/${payload.id}`, payload, headers);
            return response.data;
        } else {
            // Crear nuevo
            const response = await commonApiService.apiPrivate().post('/custom-menus', payload, headers);
            return response.data;
        }
    } catch (error) {
        throw new Error(error.response?.data || 'Error al guardar el menú');
    }
};

const deleteCustomMenu = async (id) => {
    try {
        const response = await commonApiService.apiPrivate().delete(`/custom-menus/${id}`, getTokenHeader());
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data || 'Error al obtener los datos');
    }
};

const customMenu = {
    getCustomMenu,
    saveOrUpdateCustomMenu,
    deleteCustomMenu
};

export default customMenu;
